<script setup lang="ts">
import { computed } from 'vue';
import Iframe from '../../General/Iframe.vue';
import Fullscreen from '../../General/Fullscreen.vue';
import { useSessionStore } from '../../../stores';
import { Session } from '../../../types/session';

const session = useSessionStore()
const summaryUrl = computed<string | null>(() => session.classContent?.[Session.summary]?.url || null)
</script>

<template>
    <Fullscreen v-if="summaryUrl" class="p-3 h-full">
        <Iframe :src="summaryUrl" orientation="full" />
    </Fullscreen>
</template>